import { useState } from "react";
import Card from "components/elements/Card/Card";
import AssetTypeIcon from "components/elements/Chip/AssetTypeIcon";
import ModalTitle from "components/elements/Dialog/ModalTitle";
import { useUploadPreprocessor } from "../../UploadPreprocessorContext";
import WarningTriangle from "components/icons/24/notifications/warning-triangle.svg";
import { AssetModel } from "lib/types/assets/AssetModel";

const TifUploadIssue = () => {
  const { selectedUploadIssue, goBackToUploadIssuesList, resolveUploadIssue } =
    useUploadPreprocessor();
  const [imageryType, setImageryType] = useState<AssetModel["type"]>();

  const onSubmit = () => {
    resolveUploadIssue(
      selectedUploadIssue,
      selectedUploadIssue.file,
      imageryType,
    );
  };

  const onCancel = () => {
    goBackToUploadIssuesList();
  };

  return (
    <div className="space-y-8">
      <div className="space-y-3">
        <ModalTitle>More information needed</ModalTitle>
      </div>

      <div>
        <p>
          So we can display the asset correctly, please let us know what data
          this is.
        </p>
      </div>

      <Card>
        <div className="flex divide-x py-4">
          <div className="mx-3 h-6 w-6 text-yellow-500">
            <WarningTriangle />
          </div>
          <div className="w-full space-y-2 px-3">
            <div>
              <h4 className="">{selectedUploadIssue.file.name}</h4>
            </div>
            <div className="flex items-center justify-between ">
              <AssetTypeIcon ext="TIF" />
            </div>
          </div>
        </div>
      </Card>

      <div>
        <select
          id="location"
          name="location"
          className="mt-1 block w-full rounded-md border-gray-300 py-6 pl-3 pr-10 text-base outline-none focus:border-4 focus:border-gray-500 focus:outline-none focus:ring-0 sm:text-sm"
          defaultValue="placeholder"
          onChange={(e) => setImageryType(e.target.value as AssetModel["type"])}
        >
          <option disabled value="placeholder">
            Please select a raster type...
          </option>
          <option value={"rasterImagery" as AssetModel["type"]}>
            Raster Imagery
          </option>
          <option value={"rasterTerrain" as AssetModel["type"]}>
            Raster Terrain
          </option>
        </select>
      </div>

      <div className="flex items-center justify-end space-x-6">
        <button onClick={onCancel}>Cancel</button>
        <button
          disabled={!imageryType}
          onClick={onSubmit}
          className="rounded-lg bg-black px-10 py-2 uppercase text-white"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default TifUploadIssue;
